import React from 'react'

import { TagIcon } from 'lucide-react'

import { useTheme, Box, Skeleton, Stack, Typography } from '@mui/material'

import { Preview } from 'components'
interface OrderPreviewProps {
  order: any
  onChange?: any,
  onRemove?: any,
  disabled?: boolean
  size?: 'small' | 'medium' | 'large'
}

export const OrderPreview = (props: OrderPreviewProps) => {
  const { order, onChange = false, onRemove = false, disabled = false, size = 'large'} = props
  const theme = useTheme()

  if (!order) return null

  return (
    <Preview size={size} item={order} onRemove={onRemove} onChange={onChange} disabled={disabled}>
        <Box sx={{ border: `1px solid ${theme.palette.grey[300]}`, borderRadius: 2}}>
          <Stack alignItems="center" justifyContent="center"
            sx={{ p: 2,width: 64, height: 64, borderRadius: 2, backgroundColor: theme.palette.grey[200]}}>
              <TagIcon strokeWidth={1} size={32} color={theme.palette.grey[500]}/>
          </Stack>
        </Box>
        <Stack spacing={2} sx={{ minWidth: 0, maxWidth: size == 'small' ? 100 : '100%' }}>
          <Typography variant="body2" noWrap>
            {`#ORD-${order?.id}`}
          </Typography>
          <Typography variant="body3" color="text.secondary" noWrap>
            {`${order?.tag_shop_products.length} items`}
          </Typography>
        </Stack>
    </Preview>
  )
}

export const OrderPreviewLoader = () => {
  return (
    <Box p={3} sx={theme => ({ border: `1px solid ${theme.palette.grey[300]}` })}>
      <Stack spacing={4} direction="row" alignItems="center">
        <Box>
          <Skeleton variant="rectangular" width={64} height={64} />
        </Box>
        <Stack spacing={2} width={'100%'}>
          <Skeleton variant="text" sx={{ fontSize: '1rem' }} width={'100%'} />
          <Skeleton variant="text" sx={{ fontSize: '1rem' }} width={'100%'} />
        </Stack>
      </Stack>
    </Box>
  )
}


export const OrderPreviewAutoComplete = (props: OrderPreviewProps) => {
  const { order } = props
  const theme = useTheme()

  if (!order) return null

  return (
    <Box p={3} sx={{borderRadius: 2 }}>
      <Stack spacing={4} direction="row" alignItems="center">
          <Box sx={{ border: `1px solid ${theme.palette.grey[300]}`, borderRadius: 2}}>
            <Stack alignItems="center" justifyContent="center"
              sx={{ p: 2,width: 64, height: 64, borderRadius: 2, backgroundColor: theme.palette.grey[200]}}>
                <TagIcon strokeWidth={1} size={32} color={theme.palette.grey[500]}/>
            </Stack>
          </Box>
        <Stack spacing={2}>
          <Typography variant="body2" noWrap>
            {`#ORD-${order?.id}`}
          </Typography>
          <Typography variant="body3" color="text.secondary" noWrap>
            {`${order?.tag_shop_products.length} items`}
          </Typography>
        </Stack>
      </Stack>
    </Box>
  )
}
